import Home from "../Home";
import NearMeSection from "../NearMeSection";
import Footer from "../../../shared/layout/Footer";
export default function HomeLayout() {
  return (
    <>
      <Home />

      <NearMeSection />
      <Footer />
    </>
  );
}
